// extracted by mini-css-extract-plugin
module.exports = {"icon":"idt-cartuploadanimation_icon__3wr2h","arrow":"idt-cartuploadanimation_arrow__1au-2"};